import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpclientService } from "../../../shared/services/httpclient.service";

@Injectable()
export class PersonService {
	constructor(private httpclientService: HttpclientService) {}
	loadPersonList(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/PersonGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
